var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0149,
    cy: 10.0305,
    r: 10,
    transform: "rotate(-0.0408361 10.0149 10.0305)",
    fill: "#7F8895"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6483 11.1018L15.6633 9.82003L10.5816 9.76042L10.6412 4.67869L9.3594 4.66365L9.29978 9.74538L4.21805 9.68576L4.20302 10.9676L9.28474 11.0272L9.22513 16.1089L10.5069 16.1239L10.5665 11.0422L15.6483 11.1018Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.e508e82d7cd255d25d7c0bc9e78beec2.svg";
export { ForwardRef as ReactComponent };